export function emit(elem, name, opts) {
    let e;
    if ("composed" in CustomEvent.prototype) {
        e = new CustomEvent(name, opts);
    }
    else {
        e = document.createEvent("CustomEvent");
        e.initCustomEvent(name, opts.bubbles, opts.cancelable, opts.detail);
        Object.defineProperty(e, "composed", { value: opts.composed });
    }
    return elem.dispatchEvent(e);
}
